<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <br />
      <el-row>
        <el-col :span="24">
          <el-table :data="tableData" style="width: 100%" stripe>
            <el-table-column type="index" width="40" align="center"> </el-table-column>

            <el-table-column prop="createTime" align="center" label="申请时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <el-table-column prop="companyName" label="发票抬头"></el-table-column>
            <el-table-column prop="regNumber" label="开票税号"></el-table-column>
            <el-table-column prop="money" label="开票金额" width="70"></el-table-column>
            <el-table-column prop="money" label="开票内容">
              <template slot-scope="scope"> <el-tag type="primary">出版费</el-tag> {{ scope.row.title }} </template>
            </el-table-column>
            <el-table-column prop="email" label="传递邮箱"></el-table-column>
            <el-table-column prop="title" label="状态">
              <template slot-scope="scope">
                <el-tag type="primary" v-if="scope.row.isIssue == 1">待处理</el-tag>
                <el-tag type="warning" v-else-if="scope.row.isIssue == 2">正在开具中</el-tag>
                <el-tag type="success" v-else-if="scope.row.isIssue == 3">已开具</el-tag>
                <el-tag type="danger" v-else-if="scope.row.isIssue == 4">已作废</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="pt" align="center" label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="openDrawer(scope.row.invoiceId, 'edit')" v-if="scope.row.invoice1 == -1 && scope.row.invoice1 == -1">编辑开票信息</el-button>
                <el-button type="default" size="mini" @click="openDrawer(scope.row.invoiceId, 'info')" v-else>查看申请信息</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row style="margin-top: 20px">
        <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="pageChange" @prev-click="pagePrev" @next-click="pageNext" style="float: right"> </el-pagination>
      </el-row>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <InvoiceEdit v-if="drawerAction == 'edit'" :invoiceId="invoiceId" @close="closeDrawer" @submitSuccess="editSuccess"></InvoiceEdit>
      <InvoiceInfo v-if="drawerAction == 'info'" :invoiceId="invoiceId" @close="closeDrawer" @intoEditing="intoEditing"></InvoiceInfo>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import InvoiceEdit from "@/components/InvoiceEdit.vue"
import InvoiceInfo from "@/components/InvoiceInfo.vue"
import invoiceApi from "@/api/invoice"

export default {
  components: { PageHeader, InvoiceEdit, InvoiceInfo },
  data() {
    return {
      headLinks: [{ path: "", title: "发票申请及记录" }],
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize: 10,

      drawer: false,
      drawerTitle: "填写发票信息",
      drawerAction: "add",
      invoiceId: null,
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    //加载数据
    loadData() {
      invoiceApi.getListByAuthor(this.curPage, this.pageSize).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    closeDrawer() {
      this.drawer = false
    },

    openDrawer(id, action) {
      this.invoiceId = id
      this.drawer = true
      this.drawerAction = action
      this.drawerTitle = this.drawerAction == "edit" ? "编辑开票信息" : "查看开票信息"
    },

    editSuccess() {
      this.closeDrawer()
      this.loadData()
    },

    intoEditing(invoiceId) {
      this.invoiceId = invoiceId
      this.drawer = true
      this.drawerAction = "edit"
      this.drawerTitle = "编辑开票信息"
    },

    pageChange(current) {
      this.curPage = current
      this.loadData()
    },
    pagePrev(current) {
      this.curPage = current
    },
    pageNext(current) {
      this.curPage = current
    },
  },
}
</script>

<style lang="scss" scoped></style>
